<script>
    import {Bar} from 'vue-chartjs'
    import Chart from 'chart.js'
    import ChartDataLabels from 'chartjs-plugin-datalabels'

    import IndicadoresAPI from "../../../api/indicadores";

    Chart.defaults.global.defaultFontColor = 'Black';
    Chart.defaults.global.defaultFontFamily = 'Roboto';

    import {mapGetters} from "vuex";


    export default {
        extends: Bar,
        plugins: [ChartDataLabels],

        props: ['filial', 'fornecedor', 'status', 'tipoRelatorio'],

        data: () => ({
            chartdata: {
                labels: [],
                datasets: []
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        ticks: {
                            stepSize: 1000000,
                            callback: function (value) {
                                var ranges = [
                                    {divider: 1e6, suffix: 'M'},
                                    {divider: 1e3, suffix: 'k'}
                                ];

                                function formatNumber(n) {

                                    for (var i = 0; i < ranges.length; i++) {
                                        if (n >= ranges[i].divider) {
                                            return (n / ranges[i].divider).toString() + ranges[i].suffix;
                                        }
                                    }
                                    return n;
                                }

                                return formatNumber(value);
                            }
                        }
                    }]
                },
                layout: {
                    padding: {
                        left: 10,
                        right: 10,
                        top: 10,
                        bottom: -10
                    }
                },
                legend: {
                    display: false
                },
                title: {
                    display: true,
                    text: '',
                    position: 'top'
                }

            }
        }),

        computed: {
            ...mapGetters({
                grupoCompra: "usuario/getGrupoCompras"
            })
        },

        watch: {

            filial(){
                this.buscarDadosGrafico();
            },

            fornecedor(){
                this.buscarDadosGrafico();
            },

            status(){
                this.buscarDadosGrafico();
            }
        },

        created() {

            this.buscarDadosGrafico();

        },

        methods: {

            buscarDadosGrafico() {

                const headers = this.Helpers.iniciarRequisicao();

                const params = {
                    grafico: true,
                    grupo: this.grupoCompra,
                    filial: this.filial,
                    fornecedor: this.fornecedor,
                    status: this.status,
                    tipo_analise: this.tipoRelatorio
                }

                this.$store.dispatch("loading/addRequisicao",
                    IndicadoresAPI.getAnaliseFinanceiro(headers,params)
                        .then(response => {

                            const token = response.data.token;
                            localStorage.setItem('token', token);

                            this.chartdata.labels = [
                                'Até 1 mês',
                                'De 1 a 2 meses',
                                'De 2 a 3 meses',
                                'De 3 a 6 meses',
                                'De 6 a 9 meses',
                                'De 9 a 12 meses',
                                'Mais de 12 meses',
                                'Sem Comportamento',
                            ];

                            this.chartdata.datasets=[];

                            const cores = ['#FFBF05', '#451145', '#00AE51', '#0071C1', '#0D0D0D'];

                            const dados = Object.values(response.data.financeiro);

                            let dadosFilial = [];

                            dados.forEach((item, index) => {

                                dadosFilial = [];

                                item.forEach(subItem =>{
                                    dadosFilial.push(subItem.total=='0.00' ? '' : subItem.total)
                                });

                                this.chartdata.datasets.push({
                                    label: 'Elevado',
                                    backgroundColor: cores[index],
                                    data: dadosFilial,
                                    datalabels: {
                                        anchor: 'end',
                                        align: 'end',
                                        rotation: -70,

                                        formatter: function (value) {

                                            var ranges = [
                                                {divider: 1e6, suffix: 'M'},
                                                {divider: 1e3, suffix: 'k'}
                                            ];

                                            function formatNumber(n) {

                                                for (var i = 0; i < ranges.length; i++) {
                                                    if (n >= ranges[i].divider) {
                                                        return (Math.round(n) / ranges[i].divider).toFixed(1).toString() + ranges[i].suffix;
                                                    }
                                                }
                                                return n;
                                            }

                                            return formatNumber(value);
                                        },

                                    },
                                });


                            });

                            this.renderChart(this.chartdata, this.options);
                        })
                        .catch(() => {
                            this.$store.dispatch("loading/habilitarLoading", false);
                            // this.Helpers.logout();
                        })
                )
            }
        }
    }
</script>
